import { PageHero, SectionLabel } from "@/components/Bits";
import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { PROCESS, IMAGES } from "@/lib/site";

export default function HowItWorks() {
  return (
    <div data-testid="how-it-works-page">
      <Seo
        title="How It Works"
        description="A disciplined six-step system for commercial insurance pipeline development: discovery, system design, specialist deployment, quality assurance, accountability, and continuous improvement."
        path="/how-it-works"
      />
      <PageHero
        eyebrow="How It Works"
        title="A six-step system for predictable execution."
        intro="Every engagement runs the same disciplined process — so results are engineered and repeatable, never dependent on any single personality."
      />

      <section className="bg-paper py-20 md:py-28">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16">
          <div className="grid grid-cols-1 gap-16 md:grid-cols-12">
            <div className="md:col-span-5">
              <div className="md:sticky md:top-28">
                <Reveal>
                  <SectionLabel num="→">The Pipeline</SectionLabel>
                  <h2 className="mt-6 font-display text-3xl font-medium leading-[1.08] tracking-tight text-ink sm:text-4xl">
                    From discovery to continuous improvement.
                  </h2>
                  <p className="mt-6 leading-relaxed text-subtext">
                    We standardize the work so quality is measured — not assumed — and improved every
                    cycle. You get transparent reporting and a pipeline you can forecast against.
                  </p>
                </Reveal>
                <Reveal delay={0.1}>
                  <div className="mt-10 overflow-hidden border border-line">
                    <img
                      src={IMAGES.workstation}
                      alt="Pipeline development specialist at work"
                      className="aspect-[4/3] w-full object-cover"
                    />
                  </div>
                </Reveal>
              </div>
            </div>

            <div className="md:col-span-6 md:col-start-7">
              <div className="border-l border-line pl-8 md:pl-10">
                {PROCESS.map((p, i) => (
                  <Reveal key={p.n} delay={i * 0.05}>
                    <div className="relative pb-12 last:pb-0">
                      <span className="absolute -left-[2.85rem] top-1 flex h-4 w-4 items-center justify-center rounded-full border border-navy bg-paper md:-left-[3.35rem]">
                        <span className="h-1.5 w-1.5 rounded-full bg-navy" />
                      </span>
                      <span className="font-mono text-xs text-clay">STEP {p.n}</span>
                      <h3 className="mt-2 font-display text-2xl font-medium tracking-tight text-ink md:text-3xl">
                        {p.title}
                      </h3>
                      <p className="mt-3 leading-relaxed text-subtext">{p.body}</p>
                    </div>
                  </Reveal>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}
